import '../App.css';

export default function CalendarFilter({ startDate, endDate, mode = 'daily', onChange }) {
  const inputType = mode === 'daily' || mode === '24h' ? 'date' : mode === 'monthly' ? 'month' : 'number';
  const disableTo = mode === '24h';

  return (
    <div className="filter-card glass">
      <p className="eyebrow">Date range</p>
      <div className="filter-row">
        <label>
          From
          <input
            type={inputType}
            value={startDate}
            min={mode === 'yearly' ? 2000 : undefined}
            maxLength={mode === 'yearly' ? 4 : undefined}
            onChange={(e) => {
              const newStart = e.target.value;
              const newEnd = mode === '24h' ? newStart : endDate;
              onChange({ startDate: newStart, endDate: newEnd });
            }}
          />
        </label>
        <label>
          To
          <input
            type={inputType}
            value={endDate}
            disabled={disableTo}
            min={mode === 'yearly' ? 2000 : undefined}
            maxLength={mode === 'yearly' ? 4 : undefined}
            onChange={(e) => onChange({ startDate, endDate: e.target.value })}
          />
        </label>
      </div>
    </div>
  );
}
